import {Component} from '@angular/core';
import {Validators} from '@angular/forms';
import {PERSON_NAME_PATTERN} from '../../../../_constants/constants';
import {DirsSubjectFormComponent} from '../dirs-subject-form/dirs-subject-form.component';
import {phoneValidator} from '../../../../_utils/validators';
import {StandardSubjectFormComponent} from '../standard-subject-form.component';

@Component({
    selector: 'app-edirs-subject-form',
    templateUrl: '../dirs-subject-form/dirs-subject-form.component.html',
    styleUrls: ['../dirs-subject-form/dirs-subject-form.component.scss'],
    imports: [StandardSubjectFormComponent]
})
export class EdirsSubjectFormComponent extends DirsSubjectFormComponent {

  constructor() {
    super();

    this.subjectFormGroup = this.formBuilder.group({
      firstName: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(16),
        Validators.pattern(PERSON_NAME_PATTERN)
      ])],
      middleName: ['', Validators.compose([
        Validators.maxLength(10),
        Validators.pattern(PERSON_NAME_PATTERN)
      ])],
      lastName: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(20),
        Validators.pattern(PERSON_NAME_PATTERN)
      ])],
      phone: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(10),
        phoneValidator
      ])]
    });
  }
}
